import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { Notificacion } from './notificacion';

import myGlobals = require('../config');

@Injectable()
export class NotificacionService {

    private alarmaUrl = myGlobals.default.BASE_URL + '/notificacion/';  // URL to web api

    constructor(private http: Http) { }

    //Obtener un resumen de notificaciones por empresa
    getResumenNotificaciones(_id: string): Observable<Notificacion> {
        return this.http.get(this.alarmaUrl + "resumen/" + _id)
            .map((response) => response.json());
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/notificacion/notificacion.service.ts